'use strict';

(function() {
var module = angular.module('client.components');

  var progressBGColorGray = '#565759'
  var progressBGColorGreen = '#7ec33e';
  var progressBGColor = progressBGColorGray;

  var ribbonBGColorGray = '#f4f4f4';
  var ribbonBGColorGreen = '#f5f34e';
  var ribbonBGColor = ribbonBGColorGray;

  var ribbonWrapBGGolorGray = '#e8e8e7';
  var ribbonWrapBGGolorGreen = '#d1c312';
  var ribbonWrapBGGolor = ribbonWrapBGGolorGray;

  var fullBGRadiantGray = '#linearGradient59';
  var fullBGRadiantGreen = '#linearGradient58';
  var fullBGRadiant = fullBGRadiantGray;

  var textLine1 = '';
  var textLine2 = '';

  var circleFinishedTour = '#f5f34e';
  var circleUntakenTour = '#ffffff';

  var svgHeader = `<svg viewBox="0 0 148.88933 131.556" height="131.556" width="148.88933" xml:space="preserve" version="1.1"
    xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/">`;

  var svgDefs = `<defs>
    <linearGradient id="linearGradient58" spreadMethod="pad" gradientTransform="matrix(0,-0.6492294,-0.7321309,0,55.962006,74.693298)"
      gradientUnits="userSpaceOnUse" y2="0" x2="100" y1="0" x1="0">
      <stop offset="0" style="stop-opacity:1;stop-color:#4e9935"/>
      <stop id="stop56" offset="1" style="stop-opacity:1;stop-color:#78bf33"/>
    </linearGradient>
    <linearGradient id="linearGradient59" spreadMethod="pad" gradientTransform="matrix(0,-0.6492294,-0.7321309,0,55.961975,74.693909)"
       gradientUnits="userSpaceOnUse" y2="0" x2="100" y1="0" x1="0">
       <stop offset="0" style="stop-opacity:1;stop-color:#8e8f8e" />
       <stop offset="1" style="stop-opacity:1;stop-color:#d8d6d4" />
     </linearGradient>
    <clipPath id="clipPath104" clipPathUnits="userSpaceOnUse">
      <path id="path102" d="M 12.5078,86.8955 H 99.159 V 65.979 H 12.5078 Z" />
    </clipPath>
    <mask id="mask118" height="1" width="1" y="0" x="0" maskUnits="userSpaceOnUse">
      <image id="image120" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAAAVCAAAAAAWMy3XAAAAAXNCSVQI5gpbmQAAAMVJREFUOI3t1U0KwjAQBeCZJLWhBaFU/FlY7RVc9QJeXQ8g0pWIK3+x2GilMElcuPEAg6u+A3w8HgyDgDKQAvjiHZEFxDCdJD3kc11zPT1IyXRR5DFfYW+r7aqsVTAulrOQs289NOeXUkmeDVj31dm0LwWGseZkAaWOAhSAgnGErywQWKv+pHM79z+ud57Z9M6Dcq15x5JTpebZekX3XU6a8ZSt2R9qq+i4tvOIcWaqyk1lEXvJiPlf3C6GEFAqiYyud0QOPr/MR2oE49VOAAAAAElFTkSuQmCC"
        preserveAspectRatio="none" style="image-rendering:optimizeSpeed" height="1" width="1" />
    </mask>
    <clipPath id="clipPath166" clipPathUnits="userSpaceOnUse">
      <path id="path164" d="M 29.4619,68.291 H 84.5895 V 17.1722 H 29.4619 Z" />
    </clipPath>
    <mask id="mask180" height="1" width="1" y="0" x="0" maskUnits="userSpaceOnUse">
      <image id="image182" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAzCAAAAAAWIc+MAAAAAXNCSVQI5gpbmQAABFpJREFUSImN1llX2zoQAOCZkSxvSZyFhlK6UNr7//8QpZTbcgkhIU68ypLmPtgsIUCjRx9/Z6SRNBqE3YGAiIgAAMzMDPzSP88/IAoSQhAhMrN11lrn+Dl95pBIep7yPSUFIbNtGq21NsY6ft0hCU+FYRRHYaA8gWyNrsqiyMtSN2ZLPnGIwgui/iBJBv04DDyBbJu6zLN1mq43edU8jfnoUEg/TkaTyWSc9OPA7+KVxSZdLm8Xd2leNZZ3HAkVJuPp4eHhZDiIQuUJAnDW1FWxWS3m17ObRZpre58g+cCC3mj64fj48GDYD31PEiEAs7VNXWbp7fRq+Ge2zCrTbUrnSAb9gw+fvnw8miRx4Emih/2ztklG4/Eo6UVqjmUHZRfNH0w/fj35cjQZhEp2qF2GYBVEcW/Q74WeQCjNo0PyB9PP376dfBj3fe9RdWlGEp4fBIGSBMwlc+eQVG9yfPrP6YdJT0l86QiRkJ4nCZy1li13TobDo5NvXz9OekrsqE4iEYFrtG63UXaz/HTy5fhVBgAoEMCZuiyqxjKDBEAvGr3/9PloHL/OAJAUWF1mm6zQzoIAlMH4+PT71/eJL19n7UVBbsq8qI0DAaR608/fT4/HkaQ3WLtIbqosK7RlAvKi4bvpQT94Y5L3awz6k+m7UawICEn1RgeTQeTR3xygDAfjg1FPCSQQKk5GyZs5eXCkomQ07PkSCYUfDwa94M2cPM7UjwdJHAgkFCrq9QJvj3AAKLww7kVKIpFQQRS8vQVPoFRhGChBhCSV8uXfk9I6kspXkpCASHhC7OkASUgpCAgACfdVgIiEiIB0X5P3G8xdBSdgZ3bL6uvQGWOdA2JrGq3Nno5d9zexa6qi0nZPZ3VZVto6YqOLfKukvhmuqYqsqA0T2zpfr/PK7OVMXazXeW1bl96lxT4B2TVFerfKasPETud3i2Va7hGQTblZLlZZbZnANflqfrPc/H2mbOtsOZ8vc+1AQPukxFGgxG7p3J5lvbm5PL+4WlUWBAAgShWEgS/fhOyafPH7/PxynjVtPAAUnh8oT9DrkF1TLK9+nl1cryoLnWNE6SlPCnwNtuzi7Pz3IjfuwTkAFEIIQtxtMQCYnc6X/12cnf8732gHnWN2zjEDEeFLkp2ps9v/Ln78+DVb15bvHexciieS2Zm6SG/+/Dw7+zVbVcbBU2eNbhpj2iaHubUMbG1TF+vF9eX52fnlbHV/PNr3lsGUbJsyS+8OD4Zx6MvufXfONrrK0sXs6vfV9WJd3V+47n1nMKUzdZ7evp9Ohv04ULLrJ3RdbNLFzex6drvKa/O8n2CGyupys5wftP2L8gjZGV3l2Wp1e7tYpFnZPLQhW/0SCRXEgyRJkq1+abNOV+kmq7aKwtOUI6L0gjCK4rg9dewaXZVFnhdl1ZitpnB7qxBReJ5SvlJSCABnTKPrWjfGPmslX2geSIj26LT5NNY6t1O2XjqO2I2HcvnCxfwf5pyk19bG8q4AAAAASUVORK5CYII="
        preserveAspectRatio="none" style="image-rendering:optimizeSpeed" height="1" width="1" />
    </mask>
  </defs>`;

var svgContent = `
  <g transform="matrix(1.3333333,0,0,-1.3333333,0,131.556)" id="g10" style="display:inline">
    <g id="g12">
      <path id="path22" style="fill:{{ribbonWrapBGGolor}};fill-opacity:1;fill-rule:nonzero;stroke:none"
        d="m 0,0 11.172,5.398 c 0.779,0.75 1.135,1.838 0.951,2.905 -0.182,1.056 -0.871,1.957 -1.844,2.407 L -1.256,11.236 -4.609,0.156 Z"
        transform="translate(84.8638,26.1074)" />
    </g>
    <g id="g24">
      <path id="path34" style="fill:{{ribbonWrapBGGolor}};fill-opacity:1;fill-rule:nonzero;stroke:none"
        d="m 0,0 -11.171,5.398 c -0.779,0.751 -1.136,1.838 -0.952,2.905 0.182,1.056 0.871,1.957 1.844,2.408 L 1.256,11.236 4.609,0.156 Z"
        transform="translate(27.1865,25.7773)" />
    </g>
    <g id="g36">
      <path id="path60" style="fill:url({{fullBGRadiant}});stroke:none"
        d="m 21.229,73.611 c -0.586,-3.754 -0.875,-7.53 -0.874,-11.298 v 0 c 0.003,-4.547 0.431,-9.079 1.275,-13.539 v 0 c 1.6,-8.449 4.718,-16.667 10.28,-23.335 v 0 c 3.058,-3.667 6.752,-6.719 10.831,-9.14 v 0 c 4.46,-2.647 9.338,-4.516 14.423,-5.528 v 0 c 4.721,1.445 9.224,3.527 13.38,6.189 v 0 c 3.949,2.53 7.585,5.565 10.517,9.263 v 0 c 4.849,6.119 7.537,13.611 9.106,21.312 v 0 c 0.961,4.716 1.407,9.485 1.401,14.268 v 0 c -0.006,3.962 -0.321,7.933 -0.911,11.891 v 0 z" />
    </g>
    <g id="g62">
      <path id="path72" style="fill:{{ribbonBGColor}};fill-opacity:1;fill-rule:nonzero;stroke:none"
        d="m 0,0 -0.098,18.207 c -0.093,0.649 0.041,1.313 0.383,1.873 0.6,0.986 1.725,1.527 2.871,1.38 H 17.699 L 12.221,12.658 17.973,3.469 3.164,3.419 C 2.372,3.295 1.641,2.92 1.076,2.35 0.452,1.718 0.07,0.886 0,0"
        transform="translate(15.0889,32.543)" />
    </g>
    <g id="g74">
      <path id="path84" style="fill:{{ribbonBGColor}};fill-opacity:1;fill-rule:nonzero;stroke:none"
        d="m 0,0 0.098,18.206 c 0.093,0.649 -0.041,1.313 -0.383,1.874 -0.6,0.986 -1.725,1.527 -2.871,1.379 h -14.543 l 5.478,-8.801 -5.752,-9.189 14.809,-0.051 C -2.371,3.294 -1.641,2.92 -1.076,2.35 -0.451,1.717 -0.07,0.885 0,0"
        transform="translate(96.961397,32.873)" />
    </g>
    <g id="g86">
      <image id="image124" mask="url(#mask118)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAAAVCAYAAAAzWHILAAAABHNCSVQICAgIfAhkiAAAAZhJREFUWIXt2UFu00AUxvH/Nx7HMU1CgxCVKpA4FZeAI7DrmTgOYtNKRIBCgVIRe+ax8DQJG5pUshDS+2288IxlfXoeed7IzGz5eM6b6YJ107OcVuRHuCOcfA+ECXzYbLi8Fu8+rwDQ6WJmr5dz6lbEGiQwA6F//Mr/EUGSERKkAN1HuFhdobfPzi0+YQg2CGw3wd0vANnKFSMgfnQZfRFx3fScNREhAoDKYPv7Q91OALIgmMhAE8X7s454XteEPNzMZbD2CtjdTyWsLMAgIp5/i4SbeSbtRSlfDo5mKl96ibHH+JrT3Uog0FDe7uGGwjSqErLnOSIPd0Qe7og83BF5uCPycEfk4Y7Iwx1RADAMbLf9dQ9jBiBS2eXG8BOqqbb7YsObNsfKDLuzUAq0ljgNFdE2kCeAdr3cuwnuMEF/5tUF43LRE3Ur+plRm4aqpQz0Bs7Btv1cg4ShDl58qoeTiFdPW16eTMgYOUBlwszXhkNJbPuNqYPNupxE7J+hWWvM2sBNyrTJfyQOdVtlrAH9Aq7FxeoKgN/c75IDYIojcQAAAABJRU5ErkJggg=="
        transform="matrix(86.651215,0,0,-20.916483,12.507813,86.895508)" preserveAspectRatio="none" style="opacity:0.5;image-rendering:optimizeSpeed" height="1" width="1" />
    </g>
    <g id="g136">
      <path id="path146" style="fill:{{progressBGColor}};fill-opacity:1;fill-rule:nonzero;stroke:none"
        d="m 0,0 h 75.077 c 1.111,0 1.777,0 2.222,-0.186 0.641,-0.233 1.147,-0.738 1.379,-1.379 0.186,-0.444 0.186,-1.112 0.186,-2.223 v -9.342 c 0,-1.111 0,-1.777 -0.186,-2.223 -0.232,-0.64 -0.738,-1.145 -1.379,-1.378 -0.445,-0.186 -1.111,-0.186 -2.222,-0.186 H 0 c -1.111,0 -1.778,0 -2.223,0.186 -0.641,0.233 -1.145,0.738 -1.379,1.378 -0.185,0.446 -0.185,1.112 -0.185,2.223 v 9.342 c 0,1.111 0,1.779 0.185,2.223 0.234,0.641 0.738,1.146 1.379,1.379 C -1.778,0 -1.111,0 0,0"
          transform="translate(18.2949,85.8955)" />
    </g>
    <g id="g148">
      <image id="image186" mask="url(#mask180)" xlink:href="data:image/png;base64,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"
        transform="matrix(55.127596,0,0,-51.118827,29.461914,68.291015)" preserveAspectRatio="none" style="opacity:0.699997;image-rendering:optimizeSpeed" height="1" width="1" />
    </g>
    <g id="g198">
      <path id="path208" style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
        d="m 0,0 c 9.201,-8.419 9.201,-22.07 0,-30.489 -9.203,-8.42 -24.123,-8.42 -33.325,0 -9.202,8.419 -9.202,22.07 0,30.489 C -24.123,8.419 -9.203,8.419 0,0"
        transform="translate(72.688,59.708)" />
    </g>
    {{progressCircles}}
    <text id="text250" style="font-variant:normal;font-weight:normal;font-stretch:normal;font-size:9px;font-family:'Helvetica Neue';writing-mode:lr-tb;fill:#110f0d;fill-opacity:1;fill-rule:nonzero;stroke:none"
      transform="matrix(1,0,0,-1,36.8643,47.7109)">
      <tspan id="tspan246" y="0" x="0">{{textLine1}}</tspan>
      <tspan id="tspan248" y="11" x="0">{{textLine2}}</tspan>
    </text>
  </g>
`;

var svgFooter = `</svg>`;

module.directive('xpTourIcon', ['$log',
function ($log) {

  return {
    restrict: 'E',
    scope: {
      topic: '=',
      tours: '='
    },
    replace: true,
    template: require('./tourIcon.jade'),
    link: function (scope, element) {

      function getCircleColor(tour) {
        if (tour.tour_status) {
          return circleFinishedTour;
        } else {
          return circleUntakenTour;
        }
      }

      function getCircleSvg() {
        var adjustment = 15;
        var gap = 80 / scope.tours.length;
        var circles = scope.tours.map(function(tour, index) {
          return '<g><circle cx="' + (adjustment + ((index * gap) + gap / 2)) + '" cy="78" r="6" fill="' + getCircleColor(tour) + '"/></g>';
        });
        return circles.join("\r\n");
      }

      function assignColors() {
        var progress = scope.tours.find(function(tour) {
          return tour.tour_status;
        });
        if (progress) {
          progressBGColor = progressBGColorGreen;
          ribbonBGColor = ribbonBGColorGreen;
          ribbonWrapBGGolor = ribbonWrapBGGolorGreen;
          fullBGRadiant = fullBGRadiantGreen;
        } else {
          progressBGColor = progressBGColorGray;
          ribbonBGColor = ribbonBGColorGray;
          ribbonWrapBGGolor = ribbonWrapBGGolorGray;
          fullBGRadiant = fullBGRadiantGray;
        }
      }

      function assignText() {
        var words = scope.topic.split(' ');
        if (words && words.length) {
          textLine1 = words[0];
          if (words.length == 2) {
            textLine2 = words[1];
          } else if (words.length > 2) {
            textLine2 = words[2];
            if (words[0].length < words[2].length) {
              textLine1 = words[0] + ' ' + words[1];
            } else {
              textLine2 = words[1] + ' ' + words[2];
            }
          }
        }
        textLine1 = textLine1.toUpperCase();
        textLine2 = textLine2.toUpperCase();
      }

      scope.getImage = function() {
        assignColors();
        assignText();

        var svgImage = svgHeader + svgDefs + svgContent + svgFooter;
        svgImage = svgImage.replaceAll('{{progressBGColor}}', progressBGColor);
        svgImage = svgImage.replaceAll('{{ribbonBGColor}}', ribbonBGColor);
        svgImage = svgImage.replaceAll('{{ribbonWrapBGGolor}}', ribbonWrapBGGolor);
        svgImage = svgImage.replaceAll('{{fullBGRadiant}}', fullBGRadiant);
        svgImage = svgImage.replaceAll('{{textLine1}}', textLine1);
        svgImage = svgImage.replaceAll('{{textLine2}}', textLine2);
        svgImage = svgImage.replaceAll('{{progressCircles}}', getCircleSvg());

        return 'data:image/svg+xml;base64,' + window.btoa(svgImage);
      };
    }
  };
}]);

})();

